import React, { useEffect, useRef, useState } from 'react';

export default function Description({
  description = '',
  descriptionHtml = '',
  collapsible = true,
}: {
  description?: string;
  descriptionHtml?: string;
  collapsible?: boolean;
}) {
  const [expanded, setExpanded] = useState(!collapsible);
  const [needsToggle, setNeedsToggle] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const check = () => {
      if (expanded) return;
      const overflowing = el.scrollHeight > el.clientHeight + 1;
      setNeedsToggle(overflowing);
    };

    check();
    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, [description, descriptionHtml, expanded]);

  const hasContent = !!description || !!descriptionHtml;
  if (!hasContent) return null;

  return (
    <div className="description" style={{ marginTop: 12 }}>
      <div
        ref={contentRef}
        style={{
          lineHeight: 1.55,
          fontSize: 14,
          color: 'inherit',
          display: expanded ? 'block' : '-webkit-box',
          WebkitBoxOrient: 'vertical' as any,
          WebkitLineClamp: expanded ? ('unset' as any) : 2,
          overflow: expanded ? 'visible' : 'hidden',
          maxHeight: expanded ? 'none' : '3.1em',
        }}
      >
        {descriptionHtml ? (
          <div className="html-content" dangerouslySetInnerHTML={{ __html: descriptionHtml.replace(/<(\/?)h1(?=[\s>])/gi, '<$1h2') }} />
        ) : (
          <p style={{ margin: 0 }}>{description}</p>
        )}
      </div>
      {needsToggle && (
        <button
          type="button"
          aria-expanded={expanded}
          onClick={() => setExpanded(prev => !prev)}
          style={{
            marginTop: 6,
            background: 'transparent',
            border: 'none',
            padding: '4px 0',
            color: '#186d4e',
            fontSize: 13,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          {expanded ? 'Daha Az' : 'Devamını Oku'}
        </button>
      )}
    </div>
  );
}

Description.defaultProps = { description: '', descriptionHtml: '', collapsible: true };
